import { fetchWithAuth } from "./FetchHelper";

const apiUrl = process.env.REACT_APP_API_URL;

export async function GetAulaRaConfig(idAula: string) {
    try {
        const response = await fetchWithAuth(`${apiUrl}:8061/jutge/aules/${idAula}/ra-config`);
        if (response && response.ok) {
            return await response.json();
        }
        return [];
    } catch (error) {
        console.error(error);
        return [];
    }
}
